import { toRaw } from 'vue';
import { FormValidator, type FormValidatorConfig, type FormValidatorContext, type FormValidatorSettings } from '../models';
import { isEmpty } from '../utils';

export interface DateIsBeforeValidatorSettings extends FormValidatorSettings {
  dateToCompare: Date | null;
  allowEqual: boolean;
  otherFieldName: string;
}

export type DateIsBeforeValidatorConfig = FormValidatorConfig<DateIsBeforeValidatorSettings>;

export class DateIsBeforeValidator extends FormValidator<DateIsBeforeValidatorSettings> {
  constructor() {
    super();
    this._name = 'dateIsBefore';
    this._settings = {
      invalidMessage: 'form.validator.dateIsBefore.invalidMessage',
      needTranslate: true,
      dateToCompare: null,
      allowEqual: true,
      otherFieldName: ''
    };
  }

  public override async onValidate(value: any, context: FormValidatorContext) {
    if (isEmpty(value)) {
      this.reset();
      return;
    }

    const values = toRaw(context.values);

    const compareDate = this.settings.dateToCompare ? this.settings.dateToCompare : new Date(values[this.settings.otherFieldName]);

    const dateValue = new Date(value);
    this._valid = this.settings.allowEqual ? dateValue <= compareDate : value < compareDate;

    if (!this._valid) {
      this.addMessage(this.settings.invalidMessage, 'error', { dateToCompare: compareDate.toLocaleDateString() });
    }
  }
}
